<template>
  <div>
    <b-table
        :items="rows"
        :fields="fields"
        small
        hover
        responsive
        sort-by="peak"
        show-empty
        empty-text="В чартах не было"
    >
      <template #cell(title)="{ item }">
        <b-link @click="openHistory(item.song_id)">{{ item.artist_name }} — {{ item.title }}</b-link>
      </template>
      <template #cell(peak)="{ item }">
        <b-badge :variant="item.peak === 1 ? 'warning' : 'light-primary'">#{{ item.peak }}</b-badge>
      </template>
    </b-table>
    <chart-song-history-modal v-model="isHistoryVisible" :song-id="historySongId"/>
  </div>
</template>

<script>
import { BTable, BLink, BBadge } from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'
import ChartSongHistoryModal from './ChartSongHistoryModal.vue'

export default {
  components: {
    BTable, BLink, BBadge, ChartSongHistoryModal,
  },
  props: {
    songs: { type: Array, default: () => [] },
    chartFilter: { type: String, default: null },
  },
  setup(props) {
    const isHistoryVisible = ref(false)
    const historySongId = ref(null)

    const fields = [
      { key: 'chart_name', label: 'Чарт', sortable: true },
      { key: 'title', label: 'Песня / альбом' },
      { key: 'peak', label: 'Пик', sortable: true },
      { key: 'weeks_total', label: 'Недель', sortable: true },
      { key: 'weeks_at_1', label: 'На №1', sortable: true },
      { key: 'first_week', label: 'Первая неделя', sortable: true },
      { key: 'last_week', label: 'Последняя', sortable: true },
    ]

    // Строка = песня × чарт
    const rows = computed(() => props.songs.flatMap(song => (song.stats || [])
      .filter(stat => !props.chartFilter || stat.chart_slug === props.chartFilter)
      .map(stat => ({
        ...stat,
        song_id: song.id,
        title: song.title,
        artist_name: song.artist_name,
      }))))

    const openHistory = songId => {
      historySongId.value = songId
      isHistoryVisible.value = true
    }

    return {
      fields, rows, isHistoryVisible, historySongId, openHistory,
    }
  },
}
</script>
